/** Total inactivity before auto sign-out. */
export const IDLE_TIMEOUT_MS = 60 * 60 * 1000;

/** Warning shown this long before sign-out. */
export const IDLE_WARNING_BEFORE_MS = 60 * 1000;
